export enum GameType {
  MarvelChampions = "marvelchampions",
  LordOfTheRingsLivingCardGame = "lotrlcg",
  ArkhamHorrorCardGame = "arkhamhorrorcardgame",
  WarOfTheRingTheCardGame = "wotr_cardgame",
  StarWarsDeckbuildingGame = "swdbg",
  StandardDeck = "standarddeck",
  Lorcana = "lorcana",
  StarWarsUnlimited = "star-wars-unlimited",
  MarvelLegendary = "marvel-legendary",
  EarthborneRangers = "earthborne-rangers",
}
